/* eslint-disable react/jsx-no-undef */
import * as React from "react";
import { useState, useEffect, FC, useCallback } from "react";
import useAuth from "../../hooks/useAuth";
import { addDays } from "@fluentui/react-calendar-compat";
import { apiCall } from "../../api/services";
import axios from "axios";
import CryptoJS from "crypto-js";
import HamburgerButton from "../../constants/ButtonController/Controller";
import {
  Button,
  Checkbox,
  ComboboxProps,
  DrawerProps,
  Input,
  Tab,
  TabList,
} from "@fluentui/react-components";
import {
  Combobox,
  Option,
  Text,
  Spinner,
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  TableBody,
  TableCell,
  TableRow,
  Table,
  TableHeader,
  TableHeaderCell,
  TableCellLayout,
  PresenceBadgeStatus,
  Avatar,
} from "@fluentui/react-components";
import HiddenSideBar from "../sideBar/hiddenSideBar/SideBarHidden";
import { Field, ProgressBar } from "@fluentui/react-components";
import styles from "./Settup.module.css";
import SettupAccess from "./Settupaccess";
import SettupAccounting from "./Settupaccounting";
import SettupCrm, { CRM_SETUP_GROUPS } from "./Settupcrm";
import SettupRetail, { RETAIL_SETUP_GROUPS } from "./Settupretail";
import SettupFo, { FO_SETUP_GROUPS } from "./Settupfo";

import {
  AppItem,
  Hamburger,
  NavCategory,
  NavCategoryItem,
  NavDivider,
  NavDrawer,
  NavDrawerBody,
  NavDrawerHeader,
  NavDrawerProps,
  NavItem,
  NavSectionHeader,
  NavSubItem,
  NavSubItemGroup,
} from "@fluentui/react-nav-preview";

import {
  Label,
  Radio,
  RadioGroup,
  Switch,
  Tooltip,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import FallbackAvater from "../../assets/images/images-RoomAvater.png";
import {
  Board20Filled,
  Board20Regular,
  BoxMultiple20Filled,
  BoxMultiple20Regular,
  DataArea20Filled,
  DataArea20Regular,
  DocumentBulletListMultiple20Filled,
  DocumentBulletListMultiple20Regular,
  HeartPulse20Filled,
  HeartPulse20Regular,
  MegaphoneLoud20Filled,
  MegaphoneLoud20Regular,
  NotePin20Filled,
  NotePin20Regular,
  People20Filled,
  People20Regular,
  PeopleStar20Filled,
  PeopleStar20Regular,
  Person20Filled,
  PersonLightbulb20Filled,
  PersonLightbulb20Regular,
  Person20Regular,
  PersonSearch20Filled,
  PersonSearch20Regular,
  PreviewLink20Filled,
  PreviewLink20Regular,
  bundleIcon,
  PersonCircle32Regular,
  AddRegular,
  BreakoutRoomRegular,
  ArrowUploadRegular,
  DeleteRegular,
  EditRegular,
  BuildingTownhouseRegular,
  BuildingTownhouse24Regular,
  BuildingTownhouse20Regular,
  Add16Regular,
} from "@fluentui/react-icons";
import {
  useId,
  Link,
  Toaster,
  useToastController,
  ToastTitle,
  ToastTrigger,
  Toast,
} from "@fluentui/react-components";
import { FetcheRooms, initializedRooms, Rooms } from "../../types/Rooms";
import { Category, InitializeRoomCategoryData } from "../../types/RoomCategory";
import { Amenity, InitAmenity } from "../../types/Amenity";
import { Hotels, initializedHotel } from "../../types/Property";
import Shadows from "../../constants/Loaders/shadow";
import { API_KEY, API_SECRET, CLOUD_NAME } from "../../constants/Constant";
import { useSignalR } from "../Global/SignalRContext";
import { useSignalRStore } from "../stores/signalRStore";
import { SignalRGlobalListeners } from "../Global/SignalRGlobalListeners";
import { RoomType, InitialRoomType } from "../../types/RoomTypes";


// Define the type with optional nullable properties
type MessageStatus = {
  Error?: string | null;
  Warning?: string | null;
  Success?: string | null;
  Intent?: "success" | "error" | "warning" | "info";
};



const Person = bundleIcon(Person20Filled, Person20Regular);
const Dashboard = bundleIcon(Board20Filled, Board20Regular);
const Announcements = bundleIcon(MegaphoneLoud20Filled, MegaphoneLoud20Regular);
const EmployeeSpotlight = bundleIcon(
  PersonLightbulb20Filled,
  PersonLightbulb20Regular
);
const Search = bundleIcon(PersonSearch20Filled, PersonSearch20Regular);
const PerformanceReviews = bundleIcon(
  PreviewLink20Filled,
  PreviewLink20Regular
);
const JobPostings = bundleIcon(NotePin20Filled, NotePin20Regular);
const Interviews = bundleIcon(People20Filled, People20Regular);
const HealthPlans = bundleIcon(HeartPulse20Filled, HeartPulse20Regular);
const TrainingPrograms = bundleIcon(BoxMultiple20Filled, BoxMultiple20Regular);
const CareerDevelopment = bundleIcon(PeopleStar20Filled, PeopleStar20Regular);
const Analytics = bundleIcon(DataArea20Filled, DataArea20Regular);
const Reports = bundleIcon(
  DocumentBulletListMultiple20Filled,
  DocumentBulletListMultiple20Regular
);



type DrawerType = Required<DrawerProps>["type"];

interface SettupProps {
  /** Open a specific screen, e.g. from global search. n changes on every request. */
  openRequest?: { value: string; n: number };
}

const Settup: React.FC<SettupProps> = ({ openRequest }) => {
  const [isDrawawerOpen, setIsDrawerOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setsuccessMessage] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRoomItem, setSelectedRoomItem] = useState<string | null>(null);
  const [selectedPropertyItem, setSelectedPropertyItem] = useState<
    string | null
  >(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { login, user } = useAuth();
  let dateString = new Date().toISOString().split("T")[0];
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [selectedValue, setSelectedValue] = useState<string>("1");
  const [roomData, setRoomData] = useState<Rooms>(initializedRooms);
  const [roomCategory, setRoomCategory] = useState<Category[]>([]);
  const [roomCategoryData, setRoomCategoryData] = useState<Category>(
    InitializeRoomCategoryData
  );
  const [roomAmenity, setRoomAmenity] = useState<Amenity[]>([]);
  const [roomTypes, setRoomTypes] = useState<RoomType[]>([]);
  const [formRoomTypes, setFormRoomTypes] = useState<RoomType[]>([]);
  const [loadAmenity, setLoadAmenity] = useState<Amenity>(InitAmenity);
  const [loadRoomTypes, setLoadRoomTypes] = useState<RoomType>(InitialRoomType);
  const [roomResponse, setRoomResponse] = useState<Rooms[]>([]);
  const [fetchProperty, setFetchProperty] = useState<Hotels[]>([]);
  const [propertyData, setPropertyData] = useState<Hotels>(initializedHotel);
  //const [roomCategoryData, setRoomCategoryData] = useState<Category>(InitializeRoomCategoryData);
  const [selectedCategoryOption, setSelectedCategoryOption] = useState<string[]>([""]);
  const [selectedRoomTypeOption, setSelectedRoomTypeOption] = useState<string[]>([""]);
  const [selectedAmenityOptions, setSelectedAmenityOptions] = useState<string[]>([""]);
  const [isInProgress, setIsInprogress] = useState<boolean>(false);
  const [selectedFormItem, setSelectedFormItem] = useState<string>("Rooms1");
  const [selectedPropertyFormItem, setSelectedPropertyFormItem] =
    useState<string>("property1");
  const [initialLoaded, setInitialLoaded] = useState(false);

  const [messageStatus, setMessageStatus] = useState<MessageStatus>({});

  /**
   * Extracts specific slices from the SignalR store for use in components.
   *
   * This hook subscribes to the SignalR store and returns only the
   * required state slices (room categories, amenities, users, bookings).
   * Keeping the selection narrow helps minimize unnecessary re-renders.
   *
   * Extend this selection by adding more slices to the returned object
   * as needed for your feature requirements.
   */
  const SRCategory = useSignalRStore((state) => state.roomCategories);
  const SRamenities = useSignalRStore((state) => state.amenities);
  const SRusers = useSignalRStore((state) => state.users);
  const SRbookings = useSignalRStore((state) => state.bookings);
  const SRRooms = useSignalRStore((state) => state.rooms);
  const SRRoomTypes = useSignalRStore((state) => state.roomTypes);
 
  const handleClick = (value: string) => {
    setSelectedValue(value);
  };

  // Global search can ask for a particular screen.
  useEffect(() => {
    if (openRequest?.value) setSelectedValue(openRequest.value);
  }, [openRequest?.n, openRequest?.value]);
  const [selectedDate, setSelectedDate] = React.useState<
    Date | null | undefined
  >(null);

  const [isOpen, setIsOpen] = React.useState(true);
  const [enabledLinks, setEnabledLinks] = React.useState(true);
  const [type, setType] = React.useState<DrawerType>("inline");
  const [isMultiple, setIsMultiple] = React.useState(true);
  const [isHovered, setIsHovered] = useState<Record<string, boolean>>({});
  const linkDestination = enabledLinks ? "" : "";
  const { hospitalityConnection } = useSignalR();
  const accessToken = localStorage.getItem("authToken");
  const [roomeImage, setRoomeImage] = useState("");
  const [uploading, setUploading] = useState(false);
    const toasterId = useId("Settuptoaster");
  const { dispatchToast } = useToastController(toasterId);


/**
 * Displays a success toast notification with a dismiss action.
 *
 * The toast includes a title ("Dismiss me") and a link-based trigger
 * that allows the user to dismiss the notification.
 *
 * @function notify
 * @returns {void} No return value. Dispatches a toast notification to the UI.
 *
 * @example
 * // Trigger a success toast with dismiss option
 * notify();
 */
const notify = () =>
  dispatchToast(
    <Toast>
      <ToastTitle
        action={
          <ToastTrigger>
            <Link>Dismiss</Link>
          </ToastTrigger>
        }
      >
      {messageStatus.Error && messageStatus.Error}
      {messageStatus.Success && messageStatus.Success}
      {messageStatus.Warning && messageStatus.Warning}
      </ToastTitle>
    </Toast>,
    { intent: messageStatus.Intent }
  );











  const goPrevious = React.useCallback(() => {
    setSelectedDate((prevSelectedDate) =>
      prevSelectedDate ? addDays(prevSelectedDate, -1) : null
    );
  }, []);

  const goNext = React.useCallback(() => {
    setSelectedDate((prevSelectedDate) =>
      prevSelectedDate ? addDays(prevSelectedDate, 1) : null
    );
  }, []);
  const toggleDrawer = () => {
    setIsDrawerOpen((prevIsOpen) => !prevIsOpen);
  };

  /****
   * Register room api
   *
   *
   * */

  const RegisterRoom = async (accessToken: any, roomData: Rooms) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: "Rooms", // Adjust the endpoint as needed
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        data: roomData, // Include roomData in the request body
      });

      if (response.error) {
        console.error("Error registering room:", response.error);
        const status: MessageStatus = {
          Error: "Error registering room", // or null
          Intent: "error"
        };
        setMessageStatus(status);       
        return null;
      }
      const status: MessageStatus = {
          Error: "Room registered successfully", // or null
          Intent: "success"
        };
        setMessageStatus(status);
      return response;
    } catch (error) {
      console.error("Error registering room:", error);
       const status: MessageStatus = {
          Error: "Error registering room", // or null
          Intent: "error"
        };
        setMessageStatus(status);
      return null;
    }
  };

  /***
   * * Register room category api
   * *
   */
  const RegisterRoomCategory = async (
    accessToken: string,
    roomCategoryData: Category
  ) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: "RoomCategory",
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        data: roomCategoryData,
      });

      if (response.error) {
        console.error("Error registering room category:", response.error);
        return null;
      }

      return response;
    } catch (error) {
      console.error("Error registering room category:", error);
      return null;
    }
  };

  /***
   * * Register room category api
   * *@accessToken string
   * * *@loadAmenity Amenity
   * *
   */
  const RegisterRoomAmenity = async (access: string, datas: Amenity) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: "Amenity",
        method: "POST",
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "application/json",
        },
        data: datas,
      });

      if (response.error) {
        console.error("Error registering room category:", response.error);
        return null;
      }

      return response;
    } catch (error) {
      console.error("Error registering room category:", error);
      return null;
    }
  };

  /***
   * * Register room types api
   * *@accessToken string
   * * *@loadAmenity Amenity
   * *
   */
  const   RegisterRoomTypes = async (access: string, datas: RoomType) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: "RoomType",
        method: "POST",
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "application/json",
        },
        data: datas,
      });

      if (response.error) {
        console.error("Error registering room category:", response.error);
        return null;
      }

      return response;
    } catch (error) {
      console.error("Error registering room category:", error);
      return null;
    }
  };
  
  /***
   * * Handle input changes for room form
   */
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setRoomData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  /***
   * * Handle input changes for room category form
   */
  const handleCategoryChange = (c: any) => {
    const { name, value } = c.target;
    setRoomCategoryData((prevCate) => ({
      ...prevCate,
      [name]: value,
    }));
  };

 /// Handle input changes for room type form
const handleRoomTypeChange = async (ev: React.ChangeEvent<HTMLInputElement>) => {
    const value = ev.target.value;
     console.log("THE ROOM TYPE VALUE:", value);
  try {
    setLoading(true);
    const response = await fetchAllRoomsearch(user.token, value);
    setFormRoomTypes(response);
    setLoading(false);
    console.log("THE ROOM TYPE RESPONSE:", response);
  } catch (error) {
    console.error("Error fetching room types:", error);
    setLoading(false);
  }
  };
  /**
   * * Handle input changes for property form
   * ***/
  const handlePropertyChange = (e: any) => {
    const { name, value } = e.target;
    setPropertyData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //Handle input changes for room amenity form
  // Generic change handler for Amenity fields
  const handleAmenityChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    setLoadAmenity((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleRoomTypesChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    setLoadRoomTypes((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  //Fetch all Properties

  const fetchHotels = async (accessToken: any): Promise<void> => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: "hotels",
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      if (!response || response.error) {
        console.error(
          "Error fetching hotels:",
          response?.error || "Unknown error"
        );
        return; // Exit the function gracefully without further execution
      }

      setFetchProperty(response); // Ensure setFetchProperty is properly defined and handles state update
    } catch (error) {
      console.error("Unexpected error fetching hotels:", error);
    }
  };

  //register Property
  const RegisterProperty = async (accessToken: string, newProperty: Hotels) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: "hotels", // property  endpoint
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        data: newProperty, // Include roomData in the request body
      });

      if (response.error) {
        console.error("Error registering room:", response.error);
        return null;
      }

      return response;
    } catch (error) {
      console.error("Error registering room:", error);
      return null;
    }
  };

  //fetch room category
  const FetchAllRoomCategory = async (accessToken: any, query: string) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: `RoomCategory/search?query=${query}`, // Adjust the endpoint as needed
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      if (response.error) {
        console.error("Error fetching room categories:", response.error);
        return [];
      }

      return response;
    } catch (error) {
      console.error("Error fetching room categories:", error);
      return [];
    }
  };

  //fetch room category
  const FetchRoomCategory = async () => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: `RoomCategory`, // Adjust the endpoint as needed
        method: "GET",
        headers: {
          Authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.error) {
        console.error("Error fetching room categories:", response.error);
        return [];
      }

      return response;
    } catch (error) {
      console.error("Error fetching room categories:", error);
      return [];
    }
  };

  //feth room amenity

  const FetchAllRoomAmenity = async (accessToken: any, query: string) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: `Amenity/search?query=${query}`, // Adjust the endpoint as needed
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      if (response.error) {
        console.error("Error fetching room categories:", response.error);
        return [];
      }

      return response;
    } catch (error) {
      console.error("Error fetching room categories:", error);
      return [];
    }
  };

  //Fetch Rooms
  const FetchAllRoom = async (accessToken: any) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: "Rooms", // Adjust the endpoint as needed
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      if (response.error) {
        console.error("Error fetching rooms:", response.error);
        return [];
      }

      return response;
    } catch (error) {
      console.error("Error fetching rooms:", error);
      return [];
    }
  };

  //Room Registrations
  const handleRegisterRoom = async () => {
    setIsInprogress(true);
    const response = await RegisterRoom(accessToken, roomData);
    if (response) {
      console.log("Room registered successfully:", response);
      setIsInprogress(false);
      notify();
    }
  };


  const handleRegisterProperty = async () => {
    setIsInprogress(true);
    const response = await RegisterProperty(user.token, propertyData);
    if (response) {
      console.log("Room registered successfully:", response);
      setIsInprogress(false);
    }
  };


  /**   * Deletes a specific room by ID and shows toast feedback.
     *
     * @param access - The access token for authentication.
     * @param id - The unique identifier of the room to delete.
     * @returns The API response or an empty object if an error occurs.
     */

  const deleteRoom = async (access: string, id: string | number) => {
    try {
      // Perform DELETE request to the amenity endpoint with the given ID
      const response = await apiCall({
        service: "property",
        endpoint: `Rooms/${id}`, // Target the specific amenity
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "application/json",
        },
      });

      // Handle API errors gracefully
      if (response.error) {
        return {};
      }

      console.log("Amenity deleted successfully:", response);
      // Success toast

      return response;
    } catch (error) {
      // Catch unexpected runtime or network errors

      console.error("Unexpected error deleting amenity:", error);
      return {};
    }
  };

  /**
   * 
   * @param access 
   * @param id 
   * @returns 
   */
  const deleteProperty = async (access: string, id: string | number) => {
    setIsInprogress(true);
    try {
      // Perform DELETE request to the amenity endpoint with the given ID
      const response = await apiCall({
        service: "property",
        endpoint: `hotels/${id}`, // Target the specific amenity
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "application/json",
        },
      });
      // Handle API errors gracefully
      if (response.error) {
        setIsInprogress(false);
        return {};
      }
      setIsInprogress(false);
      console.log("Property deleted successfully:", response);
      // Success toast

      return response;

    } catch (error) {
      // Catch unexpected runtime or network errors
      setIsInprogress(false);
      console.error("Unexpected error deleting property:", error);
      return {};
    }
  };



  /**
   * * * Fetch room category based on user input
   */
  const fetchCategories = React.useCallback(
    async (query: string) => {
      setLoading(true);
      const categories = await FetchAllRoomCategory(accessToken, query);
      setRoomCategory(categories);
      setLoading(false);
    },
    [accessToken]
  );

  /**
   * * * Fetch room amenity based on user input
   */
  const fetchAmenity = useCallback(
    async (query: string) => {
      const amenities = await FetchAllRoomAmenity(accessToken, query);
      setRoomAmenity(amenities);
      if (roomAmenity) {
        setLoading(false);
      }
      console.log("THE AMENITY DATA:", amenities);
    },
    [accessToken, roomAmenity]
  );

  /**
   *
   * @param e event
   * Handle room amenity input changes
   */

  const handleRoomAmenityChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = ev.target.value;
    fetchAmenity(selectedValue); // Trigger fetching based on user input
  };

  // Use the type of the handler from ComboboxProps
  // const onOptionSelect: ComboboxProps["onOptionSelect"] = (ev, data) => {
  //     console.log("Selected Amenity for Option Select:", data.optionValue);
  //     const selectedValue = data.optionValue;
  //      setSelectedAmenityOptions(data.selectedOptions);
  //      if(!selectedValue) return;
  //     const amenity = roomAmenity.find(
  //     c => c.amenityId === Number(selectedValue)
  //   );

  //   // Update input field value
  //   setRoomData((prevData) => ({
  //     ...prevData,
  //     ["amenityId"]: amenity ? amenity.amenityId.toString() : selectedValue,  // use dynamic key
  //   }));
  //   };


  function createOptionSelectHandler<T>(
    setSelected: (values: string[]) => void,
    dataset: T[],
    key: keyof Rooms, // e.g. "amenityId" | "serviceId" | "roomTypeId"
    matchFn: (item: T, selectedValue: string) => boolean,
    getValue: (item: T, selectedValue: string) => string
  ): ComboboxProps["onOptionSelect"] {
    return (ev, data) => {
      console.log("Selected value:", data.optionValue);
      const selectedValue = data.optionValue;
      setSelected(data.selectedOptions);

      if (!selectedValue) return;

      const match = dataset.find(item => matchFn(item, selectedValue));

      setRoomData(prevData => ({
        ...prevData,
        [key]: match ? getValue(match, selectedValue) : selectedValue,
      }));
    };
  }



  // Amenity combobox
  const amenityHandler = createOptionSelectHandler(
    setSelectedAmenityOptions,
    roomAmenity,
    "amenities",
    (c, val) => c.amenityId === Number(val),
    (c, val) => c.amenityId.toString()
  );

  // category combobox
  const categoryHandler = createOptionSelectHandler(
    setSelectedCategoryOption,
    roomCategory,
    "roomCategory",
    (s, val) => s.categoryId === Number(val),
    (s, val) => s.categoryId.toString()
  );

  // room type combobox
  const RoomTypeHandler = createOptionSelectHandler(
    setSelectedRoomTypeOption,
    roomTypes,
    "roomType",
    (r, val) => r.roomTypeId === Number(val),
    (r, val) => r.roomTypeId.toString()
  );

  /**
   *
   * @param e
   * Handle room category input changes
   *
   */

  const handleRoomCategoryChange = (e: any) => {
    var selectedValue = e.target.value;
    console.log("SELECTED VALUE: ", selectedValue);
    fetchCategories(selectedValue); // Trigger fetching based on user input
  };

  /**
   *
   * @param access
   * @returns
   */
  const fetchAllAmenity = async (access: any) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: "Amenity", // Adjust the endpoint as needed
        method: "GET",
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "application/json",
        },
      });

      if (response.error) {
        console.error("Error fetching rooms:", response.error);
        return [];
      }
      console.log("Amenity fetched successfully:", response);
      return response;
    } catch (error) {
      console.error("Error fetching rooms:", error);
      return [];
    }
  };


  /**
   * fetch all Room types
   * @param access
   * @returns
   */
  const fetchAllRoomTypes = async (access: any) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: "RoomType", // Adjust the endpoint as needed
        method: "GET",
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "application/json",
        },
      });

      if (response.error) {
        console.error("Error fetching rooms:", response.error);
        return [];
      }
      console.log("RoomType fetched successfully:", response);
      return response;
    } catch (error) {
      console.error("Error fetching rooms:", error);
      return [];
    }
  };

/**
   * fetch all Room types based on user input
   * @param access
   * @returns
   */

   const fetchAllRoomsearch = async (access: any, query:any) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: `RoomType/search?searchTerm=${query}`, // Adjust the endpoint as needed
        method: "GET",
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "application/json",
        },
      });

      if (response.error) {
        console.error("Error fetching rooms:", response.error);
        return [];
      }
      console.log("RoomType fetched successfully:", response);
      return response;
    } catch (error) {
      console.error("Error fetching rooms:", error);
      return [];
    }
  };




  /**
   * Deletes a specific amenity by ID and shows toast feedback.
   *
   * @param access - The access token for authentication.
   * @param id - The unique identifier of the amenity to delete.
   * @returns The API response or an empty object if an error occurs.
   */


  const deleteAmenity = async (access: string, id: string | number) => {
    try {
      // Perform DELETE request to the amenity endpoint with the given ID
      const response = await apiCall({
        service: "property",
        endpoint: `Amenity/${id}`, // Target the specific amenity
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "application/json",
        },
      });

      // Handle API errors gracefully
      if (response.error) {
        return {};
      }

      console.log("Amenity deleted successfully:", response);
      // Success toast

      return response;
    } catch (error) {
      // Catch unexpected runtime or network errors

      console.error("Unexpected error deleting amenity:", error);
      return {};
    }
  };

  /**
   *
   * @param id room id
   * Handle delete room
   */
  const RetrieveAllAmenity = useCallback(async () => {
    const amenities = await fetchAllAmenity(user.token);
    setRoomAmenity(amenities);
  }, [user.token]);


/*  const RetrieveAllRoomTypes = useCallback(async () => {
    const types = await fetchAllRoomTypes(user.token);
    setRoomTypes(types);
  }, [user.token]);
*/

 const RetrieveAllRoomTypes = useCallback(async () => {
    const types = await fetchAllRoomTypes(user.token);
    setRoomTypes(types);
  }, [user.token]);



  const handleDeleteItem = async (id: any) => {
    if (id) {
      deleteAmenity(user.token, id);
    }
  };

  const handleDeleteRoom = async (id: any) => {
    if (id) {
      deleteRoom(user.token, id);
    }
  };

  /***
     *
     * @param id property id
     * Handle delete property
     */
  const handleDeleteProperty = async (id: any) => {
    setIsInprogress(true);
    if (id) {
      deleteProperty(user.token, id);
    }
  };
  /***
   *
   * @param u room data
   * Handle update room
   */
  const handleUpdateitem = (u: any) => { };

  /***
   * * Fetch initial data
   * *
   * */

  // Initial fetch from API on page load
  /** 
   useEffect(() => {
      const loadInitial = async () => {
       fetchRoomCategories();
        fetchAllAvailableRooms();
     if (user.token) {
       fetchHotels(user.token);
       RetrieveAllAmenity();
 
     }
       setInitialLoaded(true);
     };
     if (!initialLoaded) {
       loadInitial();
     }
    
   }, [user.token, fetchAllAvailableRooms, initialLoaded]);
 
  *****/
  //handle property registration

  const handlePropertyRegistration = async () => {
    try {
      setIsInprogress(true);

      if (!accessToken || !propertyData) {
        console.error("Missing access token or property data: ", propertyData);
        setIsInprogress(false);
        return;
      }

      const response = await RegisterProperty(accessToken, propertyData);

      if (!response) {
        console.error("Failed to register property");
      } else {
        console.log("Response:", response);
      }
    } catch (error) {
      console.error("Unexpected error during property registration:", error);
    } finally {
      setIsInprogress(false); // Ensuring state resets even if an error occurs
    }
  };

  ///reset property form

  const handlepropertyReset = async () => {
    setPropertyData({
      hotelId: 0,
      hotelName: "",
      location: "",
      totalRooms: 0,
      rating: 0,
      contactEmail: "",
      contactPhone: "",
      createdAt: new Date(),
      airecommendations: [], // Initialize as an empty array
      greenCertifications: [], // Initialize as an empty array
      transactions: [], // Initialize as an empty array
    });
  };
  //image upload to cloudinary

  const toBase64 = (file: any) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  /**
   *
   * @param event input file event
   * @returns
   */
  const handleImageChange = async (event: any) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploading(true);

    try {
      const base64Image = await toBase64(file);
      const timestamp = Math.floor(Date.now() / 1000);

      // Create signature: SHA1 of "timestamp=...API_SECRET"
      const signatureString = `timestamp=${timestamp}${API_SECRET}`;
      const signature = CryptoJS.SHA1(signatureString).toString();

      const payload = {
        file: base64Image,
        api_key: API_KEY,
        timestamp,
        signature,
      };

      const response = await axios.post(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      setRoomeImage(response.data.secure_url);
      setRoomData((prevData) => ({
        ...prevData,
        imageUrl: response.data.secure_url,
      }));
      setUploading(false);

      // Optionally: send response.data.secure_url to your backend
    } catch (error) {
      console.error("Upload failed:", error);
      setUploading(false);
    }
  };

  /**
   * Handles saving a room amenity to the backend service.
   *
   * - Validates required data (access token and property data).
   * - Calls the API (`RegisterRoomAmenity`) to persist the amenity.
   * - Displays toast notifications for success or error outcomes.
   * - Ensures loading state (`isInprogress`) is properly reset.
   */
  const handleAmenitySave = async () => {
    try {
      // Indicate that the save process has started
      setIsInprogress(true);

      // Validate required data before making the API call
      if (!accessToken || !propertyData) {
        setIsInprogress(false);
        return;
      }

      // Attempt to register the room amenity via API
      const response = await RegisterRoomAmenity(user.token, loadAmenity);

      // Handle API response
      if (!response) {
      } else {
        console.log("Response:", response);
      }
    } catch (error) {
      // Catch unexpected runtime or network errors

      console.error("Unexpected error during property registration:", error);
    } finally {
      // Always reset loading state, regardless of success or failure
      setIsInprogress(false);
    }
  };



  
  /**
   * Handles saving a room types to the backend service.
   *
   * - Validates required data (access token and property data).
   * - Calls the API (`RegisterRoomtypes`) to persist the room types.
   * - Displays toast notifications for success or error outcomes.
   * - Ensures loading state (`isInprogress`) is properly reset.
   */
  const handleRoomTypesSave = async () => {
    try {
      // Indicate that the save process has started
      setIsInprogress(true);

      // Validate required data before making the API call
      if (!accessToken || !propertyData) {
        setIsInprogress(false);
        return;
      }

      // Attempt to register the room amenity via API
      const response = await RegisterRoomTypes(user.token, loadRoomTypes);

      // Handle API response
      if (!response) {
      } else {
        console.log("Response:", response);
      }
    } catch (error) {
      // Catch unexpected runtime or network errors

      console.error("Unexpected error during property registration:", error);
    } finally {
      // Always reset loading state, regardless of success or failure
      setIsInprogress(false);
    }
  };

  
  /**
   * Updates a specific amenity by ID and shows toast feedback.
   *
   * @param access - The access token for authentication.
   * @param id - The unique identifier of the amenity to update.
   * @param updatedData - The new data for the amenity.
   * @returns The API response or an empty object if an error occurs.
   */
  const handleUpdateItem = async (
    access: string,
    id: string | number,
    updatedData: Record<string, any>
  ) => {
    try {
      // Perform PUT request to update the amenity
      const response = await apiCall({
        service: "property",
        endpoint: `Amenity/${id}`, // Target the specific amenity
        method: "PUT",
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "application/json",
        },
        //body: JSON.stringify(updatedData),
      });

      // Handle API errors gracefully
      if (response.error) {
        return {};
      }

      // Success toast

      return response;
    } catch (error) {
      // Catch unexpected runtime or network errors

      console.error("Unexpected error updating amenity:", error);
      return {};
    }
  };

  const handleUpdateoperation = async (id: any) => {
    if (id) {
      handleUpdateItem(user.token, id, {});
    }
  };
  /**
   * * * Handle room category submission
   *
   */
  const handleSave = async () => {
    try {
      setIsInprogress(true);

      if (!accessToken || !propertyData) {
        console.error("Missing access token or property data: ", propertyData);
        setIsInprogress(false);
        return;
      }

      const response = await RegisterRoomCategory(user.token, roomCategoryData);
      if (!response) {
        console.error("Failed to register property");
      } else {
        console.log("Response:", response);
      }
    } catch (error) {
      console.error("Unexpected error during property registration:", error);
    } finally {
      setIsInprogress(false); // Ensuring state resets even if an error occurs
    }
  };

  const handleDiscard = () => {
    setRoomCategoryData(InitializeRoomCategoryData);
  };

  /**
   * * SignalR for real-time updates on room category creation
   * *
   * Listener for real-time SignalR updates via broadcast channel
   *
   * */

  // ONE-TIME FULL DATA LOAD – runs every time the page mounts
  useEffect(() => {
    console.log("Initial load effect running NOW");

    const fetchEverything = async () => {
      console.log("Starting API calls...");
      const [amenitiesRes,
        categoriesRes,
        roomRes,
      roomTypesRes] = await Promise.all([
          fetchAllAmenity(user.token),
          FetchRoomCategory(),
          FetchAllRoom(user.token),
           fetchAllRoomTypes(user.token),
        ]);


      const [amenities, categories,roomRe, roomType] = await Promise.all([
        amenitiesRes,
        categoriesRes,
        roomRes,
        roomTypesRes,
      ]);
     console.log("API calls completed.", roomType);
      // 1. Update global store (SignalR will only send deltas after this)
      useSignalRStore.getState().setAmenities(amenities);
      useSignalRStore.getState().setRoomCategories(categories);
      useSignalRStore.getState().setRoomData(roomRe);
      useSignalRStore.getState().setRoomTypes(roomType);

      // 2. Update local component state
      setRoomAmenity(amenities);
      setRoomCategory(categories);
      setRoomResponse(roomRes);
      setRoomTypes(roomType);
      console.log("Initial data fully loaded and applied");
    };

    fetchEverything();
  }, []); // ← empty array = runs exactly once when component mounts
  // 2. After that → SignalR updates come in → update local state IMMEDIATELY and correctly

  // SignalR-driven Amenity update
  useEffect(() => {
    setRoomAmenity((prev) => {
      // This prevents stale closure or unnecessary re-renders if same reference
      // But SRamenities is always the latest full list from store
      if (
        prev.length === SRamenities.length &&
        prev.every((item, i) => item.amenityId === SRamenities[i].amenityId)
      ) {
        return prev; // no change
      }
      return [...SRamenities]; // fresh full list
    });
  }, [SRamenities]);

  // SignalR-driven Room Category update
  useEffect(() => {
    setRoomCategory((prev) => {
      return [...SRCategory];
    });
  }, [SRCategory]);

  // SignalR-driven Rooms update
  useEffect(() => {
    setRoomResponse((prev) => {
      return [...SRRooms];
    });
  }, [SRRooms]);

  // SignalR-driven Room Types update
  useEffect(() => {
    setRoomTypes((prev) => {
      return [...SRRoomTypes];
    });
}, [SRRoomTypes]);  

  /*  // Fetch Hotels when user token changes
    useEffect(() => {
      if (user?.token) {
        fetchHotels(user.token);
      }
    }, [user?.token]);
  */  // Fetch Hotels when user token changes

  useEffect(() => {
    notify();
    if (user?.token) {
      fetchHotels(user.token);
    }
  }, [user?.token]);

  // Landing cards shown when no setup screen is selected
  const setupHomeCards = [
    {
      title: "Property",
      text: "Properties, rooms, room types, categories and amenities.",
      count: 5,
      start: "Added Property",
      startLabel: "Add property",
    },
    {
      title: "Access Control",
      text: "Roles, permissions and who can do what in each app.",
      count: 3,
      start: "AccessRoles",
      startLabel: "Roles",
    },
    {
      title: "Accounting",
      text: "Chart of accounts, banks, tax rates, customers and vendors.",
      count: 7,
      start: "AccActAccounts",
      startLabel: "Chart of accounts",
    },
    {
      title: "CRM",
      text: "Sales, products, service and engagement setup.",
      count: CRM_SETUP_GROUPS.reduce((n, g) => n + g.items.length, 0),
      start: `Crm:${CRM_SETUP_GROUPS[0]?.items[0]?.key ?? ""}`,
      startLabel: CRM_SETUP_GROUPS[0]?.items[0]?.title ?? "Open",
    },
    {
      title: "Retail & POS",
      text: "Stores, registers, tenders, taxes, suppliers and catalog.",
      count: RETAIL_SETUP_GROUPS.reduce((n, g) => n + g.items.length, 0),
      start: `Retail:${RETAIL_SETUP_GROUPS[0]?.items[0]?.key ?? ""}`,
      startLabel: RETAIL_SETUP_GROUPS[0]?.items[0]?.title ?? "Open",
    },
    {
      title: "Finance & Operations",
      text: "Legal entities, warehouses, partners, items and workers.",
      count: FO_SETUP_GROUPS.reduce((n, g) => n + g.items.length, 0),
      start: `Fo:${FO_SETUP_GROUPS[0]?.items[0]?.key ?? ""}`,
      startLabel: FO_SETUP_GROUPS[0]?.items[0]?.title ?? "Open",
    },
  ];

  return (
    <>
      <div className={styles.gU1Tf}>
        <div className={styles.jUsfu}>
          <div className={styles.QIl4y}>
            <div className={styles.O0VOp1}>
              <div className={`${styles.LBktY} ${styles.UEWITO}`}>
                {/* # left slide tab region
                 
              */}
                <div className={styles.SIDEBARI}>
                  <NavDrawer
                    defaultSelectedValue="2"
                    defaultSelectedCategoryValue=""
                    open={isOpen}
                    type={type}
                    multiple={isMultiple}
                  >
                    <NavDrawerBody
                      className={`${styles.customScrollBar} ${styles.HEOUWG2Y282NI}`}
                    >
                      <AppItem as="button">General Settings</AppItem>
                      <NavCategory value="88">
                        <NavCategoryItem icon={<BuildingTownhouse20Regular />}>
                          Property
                        </NavCategoryItem>
                        <NavSubItemGroup>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("Added Property")}
                            value="88"
                          >
                            <AddRegular />
                            Add Property
                          </NavSubItem>
                        </NavSubItemGroup>
                      </NavCategory>
                      <NavSectionHeader>Property Management</NavSectionHeader>
                      <NavCategory value="6">
                        <NavCategoryItem icon={<JobPostings />}>
                          Room Setups
                        </NavCategoryItem>
                        <NavSubItemGroup>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("Added Room")}
                            value="7"
                          >
                            <AddRegular />
                            Add Rooms
                          </NavSubItem>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("Room Category")}
                            value="8"
                          >
                            <AddRegular />
                            Room Category
                          </NavSubItem>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("Amenity")}
                            value="9"
                          >
                            <AddRegular />
                            Amenity
                          </NavSubItem>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("RoomTypes")}
                            value="16"
                          >
                            <AddRegular />
                            Room Types
                          </NavSubItem>
                        </NavSubItemGroup>
                      </NavCategory>
                      <NavSectionHeader>Access Control</NavSectionHeader>
                      <NavCategory value="90">
                        <NavCategoryItem icon={<JobPostings />}>
                          Roles & Permissions
                        </NavCategoryItem>
                        <NavSubItemGroup>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("AccessRoles")}
                            value="91"
                          >
                            <AddRegular />
                            Roles
                          </NavSubItem>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("AccessPermissions")}
                            value="92"
                          >
                            <AddRegular />
                            Permissions
                          </NavSubItem>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("AccessAssign")}
                            value="93"
                          >
                            <AddRegular />
                            Assign Permissions
                          </NavSubItem>
                        </NavSubItemGroup>
                      </NavCategory>
                      <NavSectionHeader>Accounting</NavSectionHeader>
                      <NavCategory value="89">
                        <NavCategoryItem icon={<JobPostings />}>
                          Accounting Setup
                        </NavCategoryItem>
                        <NavSubItemGroup>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("AccActAccounts")}
                            value="94"
                          >
                            <AddRegular />
                            Chart of accounts
                          </NavSubItem>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("AccActGroups")}
                            value="95"
                          >
                            <AddRegular />
                            Account groups
                          </NavSubItem>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("AccActBanks")}
                            value="96"
                          >
                            <AddRegular />
                            Bank accounts
                          </NavSubItem>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("AccActTaxes")}
                            value="97"
                          >
                            <AddRegular />
                            Tax rates
                          </NavSubItem>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("AccActCustomers")}
                            value="98"
                          >
                            <AddRegular />
                            Customers
                          </NavSubItem>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("AccActVendors")}
                            value="99"
                          >
                            <AddRegular />
                            Vendors
                          </NavSubItem>
                          <NavSubItem
                            href={linkDestination}
                            onClick={() => handleClick("AccActAssetCats")}
                            value="100"
                          >
                            <AddRegular />
                            Asset categories
                          </NavSubItem>
                        </NavSubItemGroup>
                      </NavCategory>
                      <NavSectionHeader>CRM</NavSectionHeader>
                      {CRM_SETUP_GROUPS.map((g, gi) => (
                        <NavCategory key={g.title} value={`crm-${gi}`}>
                          <NavCategoryItem icon={<JobPostings />}>
                            {g.title}
                          </NavCategoryItem>
                          <NavSubItemGroup>
                            {g.items.map((it) => (
                              <NavSubItem
                                key={it.key}
                                href={linkDestination}
                                onClick={() => handleClick(`Crm:${it.key}`)}
                                value={`crm:${it.key}`}
                              >
                                <AddRegular />
                                {it.title}
                              </NavSubItem>
                            ))}
                          </NavSubItemGroup>
                        </NavCategory>
                      ))}
                      <NavSectionHeader>Retail & POS</NavSectionHeader>
                      {RETAIL_SETUP_GROUPS.map((g, gi) => (
                        <NavCategory key={g.title} value={`retail-${gi}`}>
                          <NavCategoryItem icon={<JobPostings />}>
                            {g.title}
                          </NavCategoryItem>
                          <NavSubItemGroup>
                            {g.items.map((it) => (
                              <NavSubItem
                                key={it.key}
                                href={linkDestination}
                                onClick={() => handleClick(`Retail:${it.key}`)}
                                value={`retail:${it.key}`}
                              >
                                <AddRegular />
                                {it.title}
                              </NavSubItem>
                            ))}
                          </NavSubItemGroup>
                        </NavCategory>
                      ))}
                      <NavSectionHeader>Finance & Operations</NavSectionHeader>
                      {FO_SETUP_GROUPS.map((g, gi) => (
                        <NavCategory key={g.title} value={`fo-${gi}`}>
                          <NavCategoryItem icon={<JobPostings />}>
                            {g.title}
                          </NavCategoryItem>
                          <NavSubItemGroup>
                            {g.items.map((it) => (
                              <NavSubItem
                                key={it.key}
                                href={linkDestination}
                                onClick={() => handleClick(`Fo:${it.key}`)}
                                value={`fo:${it.key}`}
                              >
                                <AddRegular />
                                {it.title}
                              </NavSubItem>
                            ))}
                          </NavSubItemGroup>
                        </NavCategory>
                      ))}
                    </NavDrawerBody>
                  </NavDrawer>
                </div>

                <div className={`${styles.HEIWRB} ${styles.zzOrI}`}>
                  {selectedValue === "Added Room" && (
                    <div className={`${styles.nH} ${styles.bkK}`}>
                      <div className={`${styles.nH5}`}>
                        <div className={`${styles.room_settup}`}>
                          <div className={`${styles.HeaderItb}`}>
                            <TabList defaultSelectedValue="Rooms1">
                              <Tab
                                value="Rooms1"
                                onClick={() => setSelectedFormItem("Rooms1")}
                              >
                                Rooms
                              </Tab>
                              <Tab
                                value="Rooms2"
                                icon={<Add16Regular />}
                                onClick={() => setSelectedFormItem("Rooms2")}
                              >
                                Add New Room
                              </Tab>
                            </TabList>
                          </div>
                        </div>
                        {selectedFormItem === "Rooms2" && (
                          <>
                            <div
                              className={`${styles.mapContent} ${styles.customScrollBar}`}
                            >
                              <div
                                className={`${styles.map_form_renderer} ${styles.map_form_editable} ${styles.dflex}  ${styles.flexcolumn}`}
                              >
                                <div className={`${styles.map_form_sheet_bg}`}>
                                  <div
                                    className={`${styles.map_form_sheet} ${styles.positionrelative}`}
                                  >
                                    <div
                                      className={`${styles.map_field_widget} ${styles.map_field_image} ${styles.oe_avatar}`}
                                    >
                                      <img
                                        loading="lazy"
                                        className={`${styles.img} ${styles.imgFluid}`}
                                        alt="Binary file"
                                        width={100}
                                        height={100}
                                        src={roomeImage || FallbackAvater} // fallback image
                                      />
                                      <div className={`${styles.RTybGf}`}>
                                        <input
                                          type="file"
                                          className={`${styles.map_input_file} ${styles.dNone}`}
                                          accept="image/*"
                                          onChange={handleImageChange}
                                        />
                                      </div>
                                    </div>

                                    <div
                                      className={`${styles.oe_title} ${styles.mb24}`}
                                    >
                                      <div
                                        className={`${styles.map_field_widget} ${styles.map_field_radio}`}
                                      ></div>
                                      <h1>
                                        <div
                                          className={`${styles.map_field_widget} ${styles.map_required_modifier} ${styles.map_field_field_partner_autocomplete} ${styles.textBreak}`}
                                        >
                                          <div
                                            className={`${styles.mapAutocomplete} ${styles.dropdown}`}
                                          >
                                            <Input
                                              type="text"
                                              className={`${styles.mapAutocompleteInput} ${styles.map_input}`}
                                              placeholder="Roome Name"
                                              name="roomName"
                                              value={roomData?.roomName}
                                              onChange={handleChange}
                                            />
                                          </div>
                                        </div>
                                      </h1>
                                      <div
                                        className={`${styles.map_row}`}
                                      ></div>
                                    </div>

                                    <div className={`${styles.map_group}`}>
                                      <div className={`${styles.map_inner_group} ${styles.grid} ${styles.collg6}`}>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}>
                                          <label className={`${styles.map_form_label} ${styles.oe_inline}`}>
                                            Room Number
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}>
                                            <div className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="roomNumber"
                                                name="roomNumber"
                                                value={roomData?.roomNumber}
                                                placeholder="e.g 101"
                                                onChange={handleChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}>
                                          <label className={`${styles.map_form_label} ${styles.oe_inline}`}>
                                            Room Type
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}>
                                            <div className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Combobox
                                                name="roomtype"
                                                id="roomtype"
                                                className={`${styles.w300} ${styles.WNl}`}
                                                placeholder="Select a room type"
                                                onInput={handleRoomTypeChange}   // ✅ no fetch here
                                                onOptionSelect={RoomTypeHandler}      // ✅ new handler>
                                                selectedOptions={selectedRoomTypeOption}
                                              >
                                                {loading ? (
                                                  <Option
                                                    key="loading"
                                                    value=""
                                                    disabled
                                                    text=""
                                                  >
                                                    <Spinner
                                                      size="extra-tiny"
                                                      label="loading..."
                                                    />
                                                  </Option>
                                                ) : (
                                                  formRoomTypes.map((option) => (
                                                    <Option
                                                      key={option.roomTypeId}
                                                      value={option.roomTypeId.toString()} // ✅ matches amenityValue
                                                      text={option.roomTypeName}
                                                    >
                                                      {option.roomTypeName}
                                                    </Option>
                                                  ))
                                                )}
                                              </Combobox>
                                            </div>
                                          </div>
                                        </div>

                                        <div className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}>
                                          <label className={`${styles.map_form_label} ${styles.oe_inline}`}>
                                            Room category
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomCategory}`}>
                                            <div className={`${styles.map_roomCategory_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Combobox
                                                name="roomCategory"
                                                id="roomCategory"
                                                className={`${styles.w300} ${styles.WNl}`}
                                                placeholder="Select a room category"
                                                onInput={handleCategoryChange}   // ✅ no fetch here
                                                onOptionSelect={categoryHandler}      // ✅ new handler>
                                                selectedOptions={selectedCategoryOption}

                                              >
                                                {loading ? (
                                                  <Option
                                                    key="loading"
                                                    value=""
                                                    disabled
                                                    text=""
                                                  >
                                                    <Spinner
                                                      size="extra-tiny"
                                                      label="loading..."
                                                    />
                                                  </Option>
                                                ) : (
                                                  roomCategory.map((option) => (
                                                    <Option
                                                      key={option.categoryId}
                                                      value={option.categoryId.toString()} // ✅ matches amenityValue
                                                      text={option.categoryName}
                                                    >
                                                      {option.categoryName}
                                                    </Option>
                                                  ))
                                                )}
                                              </Combobox>
                                            </div>
                                          </div>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}>
                                          <label className={`${styles.map_form_label} ${styles.oe_inline}`}>
                                            Room status
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}>
                                            <div className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="status"
                                                name="status"
                                                value={roomData?.status.toString()}
                                                onChange={handleChange}
                                                placeholder="Room status"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}>
                                          <label className={`${styles.map_form_label} ${styles.oe_inline}`}>
                                            Room Rates
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}>
                                            <div className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="text"
                                                id="rate"
                                                contentBefore={
                                                  <Text size={400}>$</Text>
                                                }
                                                name="rate"
                                                value={roomData?.rate.toLocaleString()}
                                                onChange={handleChange}
                                                placeholder="e.g 45,000"
                                              />
                                            </div>
                                          </div>
                                        </div>

                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            View
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="text"
                                                id="roomView"
                                                name="roomView"
                                                value={roomData?.roomView}
                                                onChange={handleChange}
                                                placeholder="Lake View"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            Floor Number
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="number"
                                                id="floorNumber"
                                                name="floorNumber"
                                                value={roomData?.floorNumber?.toString()}
                                                onChange={handleChange}
                                                placeholder="e.g 2"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className={`${styles.map_inner_group} ${styles.grid} ${styles.collg6}`}>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            description
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="text"
                                                id="description"
                                                name="description"
                                                value={roomData?.description}
                                                onChange={handleChange}
                                                placeholder="e.g., A cozy room with a beautiful lake view and modern amenities."
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            Max Occupancy
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="number"
                                                id="maxOccupancy"
                                                name="maxOccupancy"
                                                value={roomData?.maxOccupancy.toString()}
                                                onChange={handleChange}
                                                placeholder="e.g 4"
                                              />
                                            </div>
                                          </div>
                                        </div>

                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            Amenity
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w300} ${styles.w100} ${styles.wTY100}`}
                                            >
                                              <Combobox
                                                placeholder="Select room amenity"
                                                onInput={handleRoomAmenityChange}   // ✅ no fetch here
                                                onOptionSelect={amenityHandler}      // ✅ new handler>
                                                selectedOptions={selectedAmenityOptions}

                                              >
                                                {loading ? (
                                                  <Option key="loading" value="" disabled text="Loading...">
                                                    <Spinner size="extra-tiny" label="Loading..." />
                                                  </Option>
                                                ) : (
                                                  roomAmenity.map((option) => (
                                                    <Option
                                                      key={option.amenityId}
                                                      value={option.amenityId.toString()} // ✅ matches amenityValue
                                                      text={option.amenityName}
                                                    >
                                                      {option.amenityName}
                                                    </Option>
                                                  ))
                                                )}
                                              </Combobox>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            Bed type
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="text"
                                                id="bedType"
                                                placeholder="Queen Bed"
                                                name="bedType"
                                                value={roomData?.bedType}
                                                onChange={handleChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            accessibilityFeatures
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="text"
                                                id="accessibilityFeatures"
                                                name="accessibilityFeatures"
                                                value={
                                                  roomData?.accessibilityFeatures
                                                }
                                                onChange={handleChange}
                                                placeholder="Braille Signage"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            Room Dimensions
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="text"
                                                id="roomDimensions"
                                                name="roomDimensions"
                                                value={roomData?.roomDimensions}
                                                onChange={handleChange}
                                                placeholder="e.g Standard Room 3m * 5m"
                                              />
                                            </div>
                                          </div>
                                        </div>

                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            Room Policies
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="text"
                                                id="roomPolicies"
                                                name="roomPolicies"
                                                value={roomData?.roomPolicies}
                                                onChange={handleChange}
                                                placeholder="e.g., Pets allowed with a fee, no pets allowed"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="map_notebook d-flex w-100 horizontal flex-column"></div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className={`${styles.nHFooter}`}>
                              <div
                                className={`${styles.map_form_buttons_edit} ${styles.dflex} ${styles.gap1}`}
                              >
                                <Button
                                  appearance="primary"
                                  className={`${styles.btn} ${styles.map_form_button_save}`}
                                  onClick={handleRegisterRoom}
                                >
                                  Save
                                </Button>
                                <Button
                                  type="button"
                                  className={`${styles.btn} ${styles.map_form_button_cancel}`}
                                >
                                  {" "}
                                  Discard{" "}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}

                        {selectedFormItem === "Rooms1" && (
                          <div className={`${styles.sbdocsPreview}`}>
                            <div className={`${styles.fSXvivaresize}`}>
                              <div className={`${styles.FCUdataGrid}`}>
                                <div
                                  className={`${styles.OverflowExgrid} ${styles.customScrollBar}`}
                                >
                                  <Table
                                    size="small"
                                    role="grid"
                                    aria-label="Table with paddin-table grid keyboard navigation"
                                  >
                                    <TableHeader>
                                      <TableRow>
                                        <TableHeaderCell className="autoTableCell">
                                          <Checkbox /> ID
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Name
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Discription
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Registration Date
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Last Updated
                                        </TableHeaderCell>
                                      </TableRow>
                                    </TableHeader>

                                    <TableBody>
                                      {roomResponse
                                        .filter((item) =>
                                          item?.roomName
                                            ?.toLowerCase()
                                            .includes(searchTerm.toLowerCase())
                                        )
                                        .map((item) => {
                                          const formattedDate = item.dateAdded
                                            ? new Date(
                                              item.dateAdded
                                            ).toLocaleString("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: "numeric",
                                              minute: "numeric",
                                              hour12: true,
                                            })
                                            : "N/A";

                                          return (
                                            <TableRow
                                              key={item.roomNumber}
                                              className={
                                                item.roomNumber ===
                                                  selectedRoomItem
                                                  ? "cat-nhxbackground"
                                                  : ""
                                              }
                                              onClick={() =>
                                                setSelectedRoomItem((prev) =>
                                                  prev === item.roomNumber
                                                    ? null
                                                    : item.roomNumber
                                                )
                                              }
                                            >
                                              <TableCell className="autoTableCell">
                                                <Checkbox
                                                  checked={
                                                    item.roomNumber ===
                                                    selectedRoomItem
                                                  }
                                                />{" "}
                                                {item.roomNumber}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {item.roomName}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {item.description}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {formattedDate}
                                              </TableCell>
                                              <TableCell>
                                                <TableCellLayout
                                                  className="Curspointer-event"
                                                  onMouseEnter={() =>
                                                    setIsHovered(
                                                      (prevState) => ({
                                                        ...prevState,
                                                        [item.roomId]: true,
                                                      })
                                                    )
                                                  }
                                                  onMouseLeave={() =>
                                                    setIsHovered(
                                                      (prevState) => ({
                                                        ...prevState,
                                                        [item.roomId]: false,
                                                      })
                                                    )
                                                  }
                                                >
                                                  {isHovered[
                                                    item.roomId
                                                  ] && (
                                                      <div
                                                        className={`${styles["action-buttons"]}`}
                                                      >
                                                        <DeleteRegular
                                                          className={`${styles["delete-icon-spacing"]} ${styles["bold-icon"]}`}
                                                          onClick={() =>
                                                            handleDeleteRoom(
                                                              item.roomId
                                                            )
                                                          }
                                                        />
                                                        <EditRegular
                                                          className={`${styles["delete-icon-spacing"]} ${styles["bold-icon"]}`}
                                                          onClick={() =>
                                                            handleUpdateoperation(
                                                              item.roomId
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  <div
                                                    className={
                                                      styles["date-text"]
                                                    }
                                                  >
                                                    {formattedDate ??
                                                      "No recent update"}
                                                  </div>
                                                </TableCellLayout>
                                              </TableCell>
                                            </TableRow>
                                          );
                                        })}
                                    </TableBody>
                                  </Table>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {selectedValue === "Room Category" && (
                    <div className={`${styles.nH} ${styles.bkK}`}>
                      <div className={`${styles.nH5}`}>
                        <div className={`${styles.room_settup}`}>
                          <div className={`${styles.HeaderItb}`}>
                            <TabList defaultSelectedValue="category1">
                              <Tab
                                value="category1"
                                onClick={() => setSelectedFormItem("category1")}
                              >
                                Rooms Categories
                              </Tab>
                              <Tab
                                value="category2"
                                icon={<Add16Regular />}
                                onClick={() => setSelectedFormItem("category2")}
                              >
                                Add New Room category
                              </Tab>
                            </TabList>
                          </div>
                        </div>
                        {selectedFormItem === "category2" && (
                          <>
                            <div
                              className={`${styles.mapContent} ${styles.customScrollBar}`}
                            >
                              <div
                                className={`${styles.map_form_renderer} ${styles.map_form_editable} ${styles.dflex}  ${styles.flexcolumn}`}
                              >
                                <div className={`${styles.map_form_sheet_bg}`}>
                                  <div
                                    className={`${styles.map_form_sheet} ${styles.positionrelative}`}
                                  >
                                    {/* images */}
                                    <div
                                      className={`${styles.oe_title} ${styles.mb24}`}
                                    >
                                      <div
                                        className={`${styles.map_field_widget} ${styles.map_field_radio}`}
                                      ></div>
                                      <h1>
                                        <div
                                          className={`${styles.map_field_widget} ${styles.map_required_modifier} ${styles.map_field_field_partner_autocomplete} ${styles.textBreak}`}
                                        >
                                          <div
                                            className={`${styles.mapAutocomplete} ${styles.dropdown}`}
                                          >
                                            <Input
                                              type="text"
                                              className={`${styles.mapAutocompleteInput} ${styles.map_input}`}
                                              placeholder="Category Name"
                                              name="categoryName"
                                              value={
                                                roomCategoryData?.categoryName
                                              }
                                              onChange={handleCategoryChange}
                                            />
                                          </div>
                                        </div>
                                      </h1>
                                      <div
                                        className={`${styles.map_row}`}
                                      ></div>
                                    </div>

                                    <div className={`${styles.map_group}`}>
                                      <div
                                        className={`${styles.map_inner_group} ${styles.grid} ${styles.collg6}`}
                                      >
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            Category Descriptions
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="categoryDescription"
                                                name="categoryDescription"
                                                value={
                                                  roomCategoryData?.categoryDescription
                                                }
                                                placeholder="e.g Standard Room"
                                                onChange={handleCategoryChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className={`${styles.map_notebook} ${styles.dflex} ${styles.w100} ${styles.horizontal} ${styles.flexcolumn}`}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className={`${styles.nHFooter}`}>
                              <div
                                className={`${styles.map_form_buttons_edit} ${styles.dflex} ${styles.gap1}`}
                              >
                                <Button
                                  onClick={handleSave}
                                  appearance="primary"
                                  className={`${styles.btn} ${styles.map_form_button_save}`}
                                >
                                  Save
                                </Button>
                                <Button
                                  onClick={handleDiscard}
                                  type="button"
                                  className={`${styles.btn} ${styles.map_form_button_cancel}`}
                                >
                                  {" "}
                                  Discard{" "}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}

                        {selectedFormItem === "category1" && (
                          <div className={`${styles.sbdocsPreview}`}>
                            <div
                              className={`${styles.fSXvivaresize} ${styles.customScrollBar}`}
                            >
                              <div className={`${styles.FCUdataGrid}`}>
                                <div className={`${styles.OverflowExgrid}`}>
                                  <Table
                                    size="small"
                                    role="grid"
                                    aria-label="Table with paddin-table grid keyboard navigation"
                                  >
                                    <TableHeader>
                                      <TableRow>
                                        <TableHeaderCell className="autoTableCell">
                                          <Checkbox /> ID
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Name
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Discription
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Registration Date
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Last Updated
                                        </TableHeaderCell>
                                      </TableRow>
                                    </TableHeader>

                                    <TableBody
                                      className={`${styles.customScrollBar}`}
                                    >
                                      {roomCategory
                                        .filter((item) =>
                                          item.categoryName
                                            .toLowerCase()
                                            .includes(searchTerm.toLowerCase())
                                        )
                                        .map((item) => {
                                          const formattedDate = item.dateAdded
                                            ? new Date(
                                              item.dateAdded
                                            ).toLocaleString("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: "numeric",
                                              minute: "numeric",
                                              hour12: true,
                                            })
                                            : "N/A";

                                          return (
                                            <TableRow
                                              key={item.categoryId}
                                              className={
                                                item.categoryName ===
                                                  selectedRoomItem
                                                  ? "cat-nhxbackground"
                                                  : ""
                                              }
                                              onClick={() =>
                                                setSelectedRoomItem((prev) =>
                                                  prev === item.categoryName
                                                    ? null
                                                    : item.categoryId.toString()
                                                )
                                              }
                                            >
                                              <TableCell className="autoTableCell">
                                                <Checkbox
                                                  checked={
                                                    item.categoryId.toString() ===
                                                    selectedRoomItem
                                                  }
                                                />{" "}
                                                {item.categoryId}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {item.categoryName}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {item.categoryDescription}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {formattedDate}
                                              </TableCell>
                                              <TableCell>
                                                <TableCellLayout
                                                  className="Curspointer-event"
                                                  onMouseEnter={() =>
                                                    setIsHovered(
                                                      (prevState) => ({
                                                        ...prevState,
                                                        [item.categoryId]: true,
                                                      })
                                                    )
                                                  }
                                                  onMouseLeave={() =>
                                                    setIsHovered(
                                                      (prevState) => ({
                                                        ...prevState,
                                                        [item.categoryId]:
                                                          false,
                                                      })
                                                    )
                                                  }
                                                >
                                                  {isHovered[
                                                    item.categoryId
                                                  ] && (
                                                      <div
                                                        className={`${styles["action-buttons"]}`}
                                                      >
                                                        <DeleteRegular
                                                          className={`${styles["delete-icon-spacing"]} ${styles["bold-icon"]}`}
                                                          onClick={() =>
                                                            handleDeleteItem(
                                                              item.categoryId
                                                            )
                                                          }
                                                        />
                                                        <EditRegular
                                                          className={`${styles["delete-icon-spacing"]} ${styles["bold-icon"]}`}
                                                          onClick={() =>
                                                            handleUpdateoperation(
                                                              item.categoryId
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  <div
                                                    className={
                                                      styles["date-text"]
                                                    }
                                                  >
                                                    {formattedDate ??
                                                      "No recent update"}
                                                  </div>
                                                </TableCellLayout>
                                              </TableCell>
                                            </TableRow>
                                          );
                                        })}
                                    </TableBody>
                                  </Table>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {selectedValue === "Amenity" && (
                    <div className={`${styles.nH} ${styles.bkK}`}>
                      <div className={`${styles.nH5}`}>
                        <div className={`${styles.room_settup}`}>
                          <div className={`${styles.HeaderItb}`}>
                            <TabList defaultSelectedValue="amenity1">
                              <Tab
                                value="amenity1"
                                onClick={() => setSelectedFormItem("amenity1")}
                              >
                                Rooms Amenities
                              </Tab>
                              <Tab
                                value="amenity2"
                                icon={<Add16Regular />}
                                onClick={() => setSelectedFormItem("amenity2")}
                              >
                                Add New Amenities
                              </Tab>
                            </TabList>
                          </div>
                        </div>
                        {selectedFormItem === "amenity2" && (
                          <>
                            <div
                              className={`${styles.mapContent} ${styles.customScrollBar}`}
                            >
                              <div
                                className={`${styles.map_form_renderer} ${styles.map_form_editable} ${styles.dflex}  ${styles.flexcolumn}`}
                              >
                                <div className={`${styles.map_form_sheet_bg}`}>
                                  <div
                                    className={`${styles.map_form_sheet} ${styles.positionrelative}`}
                                  >
                                    {/* images */}
                                    <div
                                      className={`${styles.oe_title} ${styles.mb24}`}
                                    >
                                      <div
                                        className={`${styles.map_field_widget} ${styles.map_field_radio}`}
                                      ></div>
                                      <h1>
                                        <div
                                          className={`${styles.map_field_widget} ${styles.map_required_modifier} ${styles.map_field_field_partner_autocomplete} ${styles.textBreak}`}
                                        >
                                          <div
                                            className={`${styles.mapAutocomplete} ${styles.dropdown}`}
                                          >
                                            <Input
                                              type="text"
                                              className={`${styles.mapAutocompleteInput} ${styles.map_input}`}
                                              placeholder="Amenity Name"
                                              name="amenityName"
                                              value={loadAmenity?.amenityName}
                                              onChange={handleAmenityChange}
                                            />
                                          </div>
                                        </div>
                                      </h1>
                                      <div
                                        className={`${styles.map_row}`}
                                      ></div>
                                    </div>

                                    <div className={`${styles.map_group}`}>
                                      <div
                                        className={`${styles.map_inner_group} ${styles.grid} ${styles.collg6}`}
                                      >
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            Category Descriptions
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="description"
                                                name="description"
                                                value={loadAmenity?.description}
                                                placeholder="e.g Free Wi-Fi"
                                                onChange={handleAmenityChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className={`${styles.map_notebook} ${styles.dflex} ${styles.w100} ${styles.horizontal} ${styles.flexcolumn}`}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className={`${styles.nHFooter}`}>
                              <div
                                className={`${styles.map_form_buttons_edit} ${styles.dflex} ${styles.gap1}`}
                              >
                                <Button
                                  onClick={handleAmenitySave}
                                  appearance="primary"
                                  className={`${styles.btn} ${styles.map_form_button_save}`}
                                >
                                  Save
                                </Button>
                                <Button
                                  onClick={handleDiscard}
                                  type="button"
                                  className={`${styles.btn} ${styles.map_form_button_cancel}`}
                                >
                                  {" "}
                                  Discard{" "}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}

                        {selectedFormItem === "amenity1" && (
                          <div className={styles.sbdocsPreview}>
                            <div
                              className={`${styles.fSXvivaresize} ${styles.customScrollBar}`}
                            >
                              <div className={styles.FCUdataGrid}>
                                <div className={styles.OverflowExgrid}>
                                  <Table
                                    size="small"
                                    role="grid"
                                    aria-label="Amenities table with keyboard navigation"
                                  >
                                    <TableHeader>
                                      <TableRow>
                                        <TableHeaderCell className="autoTableCell">
                                          <Checkbox /> ID
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Name
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Description
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Registration Date
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Last Updated
                                        </TableHeaderCell>
                                      </TableRow>
                                    </TableHeader>

                                    <TableBody
                                      className={styles.customScrollBar}
                                    >
                                      {roomAmenity
                                        .filter((item) =>
                                          item.amenityName
                                            .toLowerCase()
                                            .includes(searchTerm.toLowerCase())
                                        )
                                        .map((item) => {
                                          const formattedDate = item.dateAdded
                                            ? new Date(
                                              item.dateAdded
                                            ).toLocaleString("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: "numeric",
                                              minute: "numeric",
                                              hour12: true,
                                            })
                                            : "N/A";

                                          return (
                                            <TableRow
                                              key={item.amenityId}
                                              className={
                                                item.amenityId.toString() ===
                                                  selectedRoomItem
                                                  ? "cat-nhxbackground"
                                                  : ""
                                              }
                                              onClick={() =>
                                                setSelectedRoomItem((prev) =>
                                                  prev ===
                                                    item.amenityId.toString()
                                                    ? null
                                                    : item.amenityId.toString()
                                                )
                                              }
                                            >
                                              <TableCell className="autoTableCell">
                                                <Checkbox
                                                  checked={
                                                    item.amenityId.toString() ===
                                                    selectedRoomItem
                                                  }
                                                />{" "}
                                                {item.amenityId}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {item.amenityName}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {item.description}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {formattedDate}
                                              </TableCell>
                                              <TableCell>
                                                <TableCellLayout
                                                  className="Curspointer-event"
                                                  onMouseEnter={() =>
                                                    setIsHovered(
                                                      (prevState) => ({
                                                        ...prevState,
                                                        [item.amenityId]: true,
                                                      })
                                                    )
                                                  }
                                                  onMouseLeave={() =>
                                                    setIsHovered(
                                                      (prevState) => ({
                                                        ...prevState,
                                                        [item.amenityId]: false,
                                                      })
                                                    )
                                                  }
                                                >
                                                  {isHovered[
                                                    item.amenityId
                                                  ] && (
                                                      <div
                                                        className={`${styles["action-buttons"]}`}
                                                      >
                                                        <DeleteRegular
                                                          className={`${styles["delete-icon-spacing"]} ${styles["bold-icon"]}`}
                                                          onClick={() =>
                                                            handleDeleteItem(
                                                              item.amenityId
                                                            )
                                                          }
                                                        />
                                                        <EditRegular
                                                          className={`${styles["delete-icon-spacing"]} ${styles["bold-icon"]}`}
                                                          onClick={() =>
                                                            handleUpdateoperation(
                                                              item.amenityId
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  <div
                                                    className={
                                                      styles["date-text"]
                                                    }
                                                  >
                                                    {formattedDate ??
                                                      "No recent update"}
                                                  </div>
                                                </TableCellLayout>
                                              </TableCell>
                                            </TableRow>
                                          );
                                        })}
                                    </TableBody>
                                  </Table>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}


                  {selectedValue === "RoomTypes" && (
                    <div className={`${styles.nH} ${styles.bkK}`}>
                      <div className={`${styles.nH5}`}>
                        <div className={`${styles.room_settup}`}>
                          <div className={`${styles.HeaderItb}`}>
                            <TabList defaultSelectedValue="Roometypes1">
                              <Tab
                                value="Roometypes1"
                                onClick={() => setSelectedFormItem("Roometypes1")}
                              >
                                Room Types
                              </Tab>
                              <Tab
                                value="Roometypes2"
                                icon={<Add16Regular />}
                                onClick={() => setSelectedFormItem("Roometypes2")}
                              >
                                Add New Room Types
                              </Tab>
                            </TabList>
                          </div>
                        </div>
                        {selectedFormItem === "Roometypes2" && (
                          <>
                            <div className={`${styles.mapContent} ${styles.customScrollBar}`}>
                              <div className={`${styles.map_form_renderer} ${styles.map_form_editable} ${styles.dflex}  ${styles.flexcolumn}`}>
                                <div className={`${styles.map_form_sheet_bg}`}>
                                  <div className={`${styles.map_form_sheet} ${styles.positionrelative}`}>
                                    {/* images */}
                                    <div className={`${styles.oe_title} ${styles.mb24}`}>
                                      <div className={`${styles.map_field_widget} ${styles.map_field_radio}`}></div>
                                      <h1>
                                        <div className={`${styles.map_field_widget} ${styles.map_required_modifier} ${styles.map_field_field_partner_autocomplete} ${styles.textBreak}`}>
                                          <div className={`${styles.mapAutocomplete} ${styles.dropdown}`}>
                                            <Input
                                              type="text"
                                              className={`${styles.mapAutocompleteInput} ${styles.map_input}`}
                                              placeholder="Room types Name"
                                              name="roomTypeName"
                                              value={loadRoomTypes?.roomTypeName}
                                              onChange={handleRoomTypesChange}
                                            />
                                          </div>
                                        </div>
                                      </h1>
                                      <div className={`${styles.map_row}`}></div>
                                    </div>

                                    <div className={`${styles.map_group}`}>
                                      <div className={`${styles.map_inner_group} ${styles.grid} ${styles.collg6}`}>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}>
                                          <label className={`${styles.map_form_label} ${styles.oe_inline}`}>
                                            Room Types Descriptions
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}>
                                            <div className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="description"
                                                name="description"
                                                value={loadRoomTypes?.description}
                                                placeholder="e.g Deluxe Room"
                                                onChange={handleRoomTypesChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}>
                                          <label className={`${styles.map_form_label} ${styles.oe_inline}`}>
                                            max Occupancy
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}>
                                            <div className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="maxOccupancy"
                                                name="maxOccupancy"
                                                value={loadRoomTypes?.maxOccupancy.toString()}
                                                placeholder="e.g 4"
                                                onChange={handleRoomTypesChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        {/* <div className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}>
                                          <label className={`${styles.map_form_label} ${styles.oe_inline}`}>
                                            Room Type
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}>
                                            <div className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="roomType"
                                                name="roomType"
                                                value={roomData?.roomType}
                                                onChange={handleChange}
                                              />
                                            </div>
                                          </div>
                                        </div> */}
                                      </div>
                                       <div className={`${styles.map_inner_group} ${styles.grid} ${styles.collg6}`}>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}>
                                          <label className={`${styles.map_form_label} ${styles.oe_inline}`}>
                                            Base Price
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}>
                                            <div className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="text"
                                                id="basePrice"
                                                contentBefore={
                                                  <Text size={400}>$</Text>
                                                }
                                                name="basePrice"
                                                value={loadRoomTypes?.basePrice.toLocaleString()}
                                                onChange={handleRoomTypesChange}
                                                placeholder="e.g 45,000"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        {/* <div className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}>
                                          <label className={`${styles.map_form_label} ${styles.oe_inline}`}>
                                            max Occupancy
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}>
                                            <div className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="maxOccupancy"
                                                name="maxOccupancy"
                                                value={loadRoomTypes?.maxOccupancy.toString()}
                                                placeholder="e.g 4"
                                                onChange={handleChange}
                                              />
                                            </div>
                                          </div>
                                        </div> */}
                                        {/* <div className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}>
                                          <label className={`${styles.map_form_label} ${styles.oe_inline}`}>
                                            Room Type
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}>
                                            <div className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="roomType"
                                                name="roomType"
                                                value={roomData?.roomType}
                                                onChange={handleChange}
                                              />
                                            </div>
                                          </div>
                                        </div> */}
                                      </div>
                                    </div>
                                    <div className={`${styles.map_notebook} ${styles.dflex} ${styles.w100} ${styles.horizontal} ${styles.flexcolumn}`}></div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className={`${styles.nHFooter}`}>
                              <div className={`${styles.map_form_buttons_edit} ${styles.dflex} ${styles.gap1}`}>
                                <Button
                                  onClick={handleRoomTypesSave}
                                  appearance="primary"
                                  className={`${styles.btn} ${styles.map_form_button_save}`}>
                                  Save
                                </Button>
                                <Button
                                  onClick={handleDiscard}
                                  type="button"
                                  className={`${styles.btn} ${styles.map_form_button_cancel}`}>
                                  Discard{" "}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}

                        {selectedFormItem === "Roometypes1" && (
                          <div className={styles.sbdocsPreview}>
                            <div
                              className={`${styles.fSXvivaresize} ${styles.customScrollBar}`}
                            >
                              <div className={styles.FCUdataGrid}>
                                <div className={styles.OverflowExgrid}>
                                  <Table
                                    size="small"
                                    role="grid"
                                    aria-label="Amenities table with keyboard navigation"
                                  >
                                    <TableHeader>
                                      <TableRow>
                                        <TableHeaderCell className="autoTableCell">
                                          <Checkbox /> ID
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Name
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Description
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Registration Date
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Last Updated
                                        </TableHeaderCell>
                                      </TableRow>
                                    </TableHeader>

                                    <TableBody
                                      className={styles.customScrollBar}
                                    >
                                      {roomTypes
                                        .filter((item) =>
                                          item.roomTypeName
                                            .toLowerCase()
                                            .includes(searchTerm.toLowerCase())
                                        )
                                        .map((item) => {
                                          const formattedDate = item.createdAt
                                            ? new Date(
                                              item.createdAt
                                            ).toLocaleString("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: "numeric",
                                              minute: "numeric",
                                              hour12: true,
                                            })
                                            : "N/A";

                                          return (
                                            <TableRow
                                              key={item.roomTypeId}
                                              className={
                                                item.roomTypeId.toString() ===
                                                  selectedRoomItem
                                                  ? "cat-nhxbackground"
                                                  : ""
                                              }
                                              onClick={() =>
                                                setSelectedRoomItem((prev) =>
                                                  prev ===
                                                    item.roomTypeId.toString()
                                                    ? null
                                                    : item.roomTypeId.toString()
                                                )
                                              }
                                            >
                                              <TableCell className="autoTableCell">
                                                <Checkbox
                                                  checked={
                                                    item.roomTypeId.toString() ===
                                                    selectedRoomItem
                                                  }
                                                />{" "}
                                                {item.roomTypeId}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {item.roomTypeName}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {item.description}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {formattedDate}
                                              </TableCell>
                                              <TableCell>
                                                <TableCellLayout
                                                  className="Curspointer-event"
                                                  onMouseEnter={() =>
                                                    setIsHovered(
                                                      (prevState) => ({
                                                        ...prevState,
                                                        [item.roomTypeId]: true,
                                                      })
                                                    )
                                                  }
                                                  onMouseLeave={() =>
                                                    setIsHovered(
                                                      (prevState) => ({
                                                        ...prevState,
                                                        [item.roomTypeId]: false,
                                                      })
                                                    )
                                                  }
                                                >
                                                  {isHovered[
                                                    item.roomTypeId
                                                  ] && (
                                                      <div
                                                        className={`${styles["action-buttons"]}`}
                                                      >
                                                        <DeleteRegular
                                                          className={`${styles["delete-icon-spacing"]} ${styles["bold-icon"]}`}
                                                          onClick={() =>
                                                            handleDeleteItem(
                                                              item.roomTypeId
                                                            )
                                                          }
                                                        />
                                                        <EditRegular
                                                          className={`${styles["delete-icon-spacing"]} ${styles["bold-icon"]}`}
                                                          onClick={() =>
                                                            handleUpdateoperation(
                                                              item.roomTypeId
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  <div
                                                    className={
                                                      styles["date-text"]
                                                    }
                                                  >
                                                    {formattedDate ??
                                                      "No recent update"}
                                                  </div>
                                                </TableCellLayout>
                                              </TableCell>
                                            </TableRow>
                                          );
                                        })}
                                    </TableBody>
                                  </Table>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {selectedValue === "AccessRoles" && (
                    <SettupAccess view="Roles" token={user.token} appKey="hms" />
                  )}
                  {selectedValue === "AccessPermissions" && (
                    <SettupAccess view="Permissions" token={user.token} appKey="hms" />
                  )}
                  {selectedValue === "AccessAssign" && (
                    <SettupAccess view="RolePermissions" token={user.token} appKey="hms" />
                  )}
                  {selectedValue === "AccActAccounts" && (
                    <SettupAccounting view="Accounts" token={user.token} />
                  )}
                  {selectedValue === "AccActGroups" && (
                    <SettupAccounting view="AccountGroups" token={user.token} />
                  )}
                  {selectedValue === "AccActBanks" && (
                    <SettupAccounting view="Banks" token={user.token} />
                  )}
                  {selectedValue === "AccActTaxes" && (
                    <SettupAccounting view="Taxes" token={user.token} />
                  )}
                  {selectedValue === "AccActCustomers" && (
                    <SettupAccounting view="Customers" token={user.token} />
                  )}
                  {selectedValue === "AccActVendors" && (
                    <SettupAccounting view="Vendors" token={user.token} />
                  )}
                  {selectedValue === "AccActAssetCats" && (
                    <SettupAccounting view="AssetCategories" token={user.token} />
                  )}
                  {String(selectedValue).startsWith("Crm:") && (
                    <SettupCrm
                      key={String(selectedValue)}
                      entityKey={String(selectedValue).slice(4)}
                      token={user.token}
                    />
                  )}
                  {String(selectedValue).startsWith("Retail:") && (
                    <SettupRetail
                      key={String(selectedValue)}
                      entityKey={String(selectedValue).slice(7)}
                    />
                  )}
                  {String(selectedValue).startsWith("Fo:") && (
                    <SettupFo
                      key={String(selectedValue)}
                      entityKey={String(selectedValue).slice(3)}
                      token={user.token}
                    />
                  )}
                  {selectedValue === "4" && <div>Profile Search Content</div>}
                  {selectedValue === "5" && (
                    <div>Performance Reviews Content</div>
                  )}
                  {selectedValue === "1" && (
                    <div className={styles.setupHome}>
                      <div className={styles.setupHomeHero}>
                        <h2 className={styles.setupHomeTitle}>Setup</h2>
                        <p className={styles.setupHomeText}>
                          Configure every Cilpron app from one place. Pick an
                          area below, or use the menu on the left.
                        </p>
                      </div>
                      <div className={styles.setupHomeGrid}>
                        {setupHomeCards.map((c) => (
                          <button
                            key={c.title}
                            type="button"
                            className={styles.setupHomeCard}
                            onClick={() => handleClick(c.start)}
                          >
                            <span className={styles.setupHomeBadge}>
                              {c.title.charAt(0)}
                            </span>
                            <span className={styles.setupHomeCardTitle}>
                              {c.title}
                            </span>
                            <span className={styles.setupHomeCardText}>
                              {c.text}
                            </span>
                            <span className={styles.setupHomeCardMeta}>
                              {c.count} {c.count === 1 ? "screen" : "screens"}
                              {" · "}
                              {c.startLabel} →
                            </span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                  {selectedValue === "8" && (
                    <div>Room Category (Sub) Content</div>
                  )}
                  {selectedValue === "9" && <div>Amenity (Sub) Content</div>}
                  {selectedValue === "10" && <div>Interviews Content</div>}
                  {selectedValue === "11" && <div>Health Plans Content</div>}
                  {selectedValue === "13" && (
                    <div>Plan Information (Sub) Content</div>
                  )}
                  {selectedValue === "14" && (
                    <div>Fund Performance (Sub) Content</div>
                  )}
                  {selectedValue === "15" && (
                    <div>Training Programs Content</div>
                  )}
                  {selectedValue === "17" && (
                    <div>Career Paths (Sub) Content</div>
                  )}
                  {selectedValue === "18" && <div>Planning (Sub) Content</div>}
                  {selectedValue === "19" && <div>Workforce Data Content</div>}
                  {selectedValue === "20" && <div>Reports Content</div>}
                  {selectedValue === "Added Property" && (
                    <div className={`${styles.nH} ${styles.bkK}`}>
                      <div className={`${styles.nH5}`}>
                        <div className={`${styles.room_settup}`}>
                          <div className={`${styles.HeaderItb}`}>
                            <TabList defaultSelectedValue="property1">
                              <Tab
                                value="property1"
                                onClick={() =>
                                  setSelectedPropertyFormItem("property1")
                                }
                              >
                                Existing Properties
                              </Tab>
                              <Tab
                                value="property2"
                                icon={<Add16Regular />}
                                onClick={() =>
                                  setSelectedPropertyFormItem("property2")
                                }
                              >
                                Add New Property
                              </Tab>
                            </TabList>
                          </div>
                        </div>
                        {selectedPropertyFormItem === "property2" && (
                          <>
                            <div
                              className={`${styles.mapContent} ${styles.customScrollBar}`}
                            >
                              <div
                                className={`${styles.map_form_renderer} ${styles.map_form_editable} ${styles.dflex}  ${styles.flexcolumn}`}
                              >
                                <div className={`${styles.map_form_sheet_bg}`}>
                                  <div
                                    className={`${styles.map_form_sheet} ${styles.positionrelative}`}
                                  >
                                    <div
                                      className={`${styles.map_field_widget} ${styles.map_field_image} ${styles.oe_avatar}`}
                                    >
                                      <img
                                        loading="lazy"
                                        className={`${styles.img} ${styles.imgFluid}`}
                                        alt="Binary file"
                                        src={FallbackAvater}
                                      />
                                      <div className={`${styles.RTybGf}`}>
                                        <input
                                          type="file"
                                          className={`${styles.map_input_file} ${styles.dNone}`}
                                          accept="image/*"
                                        ></input>
                                      </div>
                                    </div>
                                    <div
                                      className={`${styles.oe_title} ${styles.mb24}`}
                                    >
                                      <div
                                        className={`${styles.map_field_widget} ${styles.map_field_radio}`}
                                      ></div>
                                      <h1>
                                        <div
                                          className={`${styles.map_field_widget} ${styles.map_required_modifier} ${styles.map_field_field_partner_autocomplete} ${styles.textBreak}`}
                                        >
                                          <div
                                            className={`${styles.mapAutocomplete} ${styles.dropdown}`}
                                          >
                                            <Input
                                              type="text"
                                              className={`${styles.mapAutocompleteInput} ${styles.map_input}`}
                                              placeholder="Name of property"
                                              name="hotelName"
                                              value={propertyData?.hotelName}
                                              onChange={handlePropertyChange}
                                            />
                                          </div>
                                        </div>
                                      </h1>
                                      <div
                                        className={`${styles.map_row}`}
                                      ></div>
                                    </div>

                                    <div className={`${styles.map_group}`}>
                                      <div
                                        className={`${styles.map_inner_group} ${styles.grid} ${styles.collg6}`}
                                      >
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            Location Property
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="location"
                                                name="location"
                                                placeholder="Location of property"
                                                value={propertyData?.location}
                                                onChange={handlePropertyChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            Total Rooms
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="totalRooms"
                                                name="totalRooms"
                                                placeholder="Total number of rooms"
                                                value={propertyData?.totalRooms.toString()}
                                                onChange={handlePropertyChange}
                                              />
                                            </div>
                                          </div>
                                        </div>

                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            Room Rates
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}>
                                            <div className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="text"
                                                id="contactPhone"
                                                name="contactPhone"
                                                placeholder="Contact Phone Number"
                                                value={
                                                  propertyData?.contactPhone
                                                }
                                                onChange={handlePropertyChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        {/* More forms */}
                                      </div>
                                      <div className={`${styles.map_inner_group} ${styles.grid} ${styles.collg6}`}>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}>
                                          <label className={`${styles.map_form_label} ${styles.oe_inline}`}>
                                            Property Ratings
                                          </label>
                                        </div>
                                        <div className={`${styles.map_cell} ${styles.map_cell_custom}`}>
                                          <div className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}>
                                            <div className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}>
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="rating"
                                                name="rating"
                                                placeholder="Property ratings"
                                                value={propertyData?.rating.toString()}
                                                onChange={handlePropertyChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom} ${styles.map_wrap_label} ${styles.textBreak} ${styles.text900}`}
                                        >
                                          <label
                                            className={`${styles.map_form_label} ${styles.oe_inline}`}
                                          >
                                            Contact Email
                                          </label>
                                        </div>
                                        <div
                                          className={`${styles.map_cell} ${styles.map_cell_custom}`}
                                        >
                                          <div
                                            className={`${styles.map_field_widget} ${styles.map_field_roomNumber}`}
                                          >
                                            <div
                                              className={`${styles.map_roomNumber_content} ${styles.dinlineFlex} ${styles.w100}`}
                                            >
                                              <Input
                                                className={`${styles.map_input}`}
                                                type="tel"
                                                id="contactEmail"
                                                name="contactEmail"
                                                placeholder="Contact Email"
                                                value={
                                                  propertyData?.contactEmail
                                                }
                                                onChange={handlePropertyChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        {/* More forms */}
                                      </div>
                                    </div>
                                    <div
                                      className={`${styles.map_notebook} ${styles.dflex} ${styles.w100} ${styles.horizontal} ${styles.flexcolumn}`}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className={`${styles.nHFooter}`}>
                              <div
                                className={`${styles.map_form_buttons_edit} ${styles.dflex} ${styles.gap1}`}
                              >
                                <Button
                                  appearance="primary"
                                  className={`${styles.btn} ${styles.map_form_button_save}`}
                                  onClick={handleRegisterProperty}
                                >
                                  Save
                                </Button>
                                <Button
                                  type="button"
                                  className={`${styles.btn} ${styles.map_form_button_cancel}`}
                                >
                                  {" "}
                                  Discard{" "}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}

                        {selectedPropertyFormItem === "property1" && (
                          <div className={`${styles.sbdocsPreview}`}>
                            <div className={`${styles.fSXvivaresize}`}>
                              <div className={`${styles.FCUdataGrid}`}>
                                <div
                                  className={`${styles.OverflowExgrid} ${styles.customScrollBar}`}
                                >
                                  <Table
                                    size="small"
                                    role="grid"
                                    aria-label="Table with paddin-table grid keyboard navigation"
                                  >
                                    <TableHeader>
                                      <TableRow>
                                        <TableHeaderCell className="autoTableCell">
                                          <Checkbox /> ID
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Name
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Location
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Total Room
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Registration Date
                                        </TableHeaderCell>
                                        <TableHeaderCell className="autoTableCell">
                                          Updated At
                                        </TableHeaderCell>
                                      </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                      {fetchProperty
                                        .filter((item) =>
                                          item.hotelName
                                            .toLowerCase()
                                            .includes(searchTerm.toLowerCase())
                                        )
                                        .map((item) => {
                                          const formattedDate = new Date(
                                            item.createdAt
                                          ).toLocaleString("en-US", {
                                            year: "numeric",
                                            month: "short",
                                            day: "numeric",
                                            hour: "numeric",
                                            minute: "numeric",
                                            hour12: true,
                                          });

                                          return (
                                            <TableRow
                                              key={item.hotelId}
                                              className={
                                                item.hotelId.toString() ===
                                                  selectedPropertyItem
                                                  ? "cat-nhxbackground"
                                                  : ""
                                              }
                                              onClick={() =>
                                                setSelectedPropertyItem(
                                                  (prev) =>
                                                    prev ===
                                                      item.hotelId.toString()
                                                      ? null
                                                      : item.hotelId.toString()
                                                )
                                              }
                                            >
                                              <TableCell className="autoTableCell">
                                                <Checkbox
                                                  checked={
                                                    item.hotelId.toString() ===
                                                    selectedPropertyItem
                                                  }
                                                />{" "}
                                                {item.hotelId}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {item.hotelName}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {item.location}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {item.totalRooms}
                                              </TableCell>
                                              <TableCell className="autoTableCell">
                                                {formattedDate}
                                              </TableCell>
                                              <TableCell>
                                                <TableCellLayout
                                                  className="Curspointer-event"
                                                  onMouseEnter={() =>
                                                    setIsHovered(
                                                      (prevState) => ({
                                                        ...prevState,
                                                        [item.hotelId]: true,
                                                      })
                                                    )
                                                  }
                                                  onMouseLeave={() =>
                                                    setIsHovered(
                                                      (prevState) => ({
                                                        ...prevState,
                                                        [item.hotelId]: false,
                                                      })
                                                    )
                                                  }
                                                >
                                                  {isHovered[
                                                    item.hotelId
                                                  ] && (
                                                      <div
                                                        className={`${styles["action-buttons"]}`}
                                                      >
                                                        <DeleteRegular
                                                          className={`${styles["delete-icon-spacing"]} ${styles["bold-icon"]}`}
                                                          onClick={() =>
                                                            handleDeleteProperty(
                                                              item.hotelId
                                                            )
                                                          }
                                                        />
                                                        <EditRegular
                                                          className={`${styles["delete-icon-spacing"]} ${styles["bold-icon"]}`}
                                                          onClick={() =>
                                                            handleUpdateoperation(
                                                              item.hotelId
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  <div
                                                    className={
                                                      styles["date-text"]
                                                    }
                                                  >
                                                    {formattedDate ??
                                                      "No recent update"}
                                                  </div>
                                                </TableCellLayout>
                                              </TableCell>
                                            </TableRow>
                                          );
                                        })}
                                    </TableBody>
                                  </Table>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                {isInProgress && <Shadows />}

                {/* <div className="GssDD"></div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settup;